/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:16a4d4f8-ed31-442d-a495-eefe75ff3698",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_U6uSA2RQi",
    "aws_user_pools_web_client_id": "687uufegs5237p9s5d5ekl9nfq",
    "oauth": {}
};


export default awsmobile;
